import Controler from '../base/Controler';
import Tab from './Tab';

class TabControler extends Controler {
  constructor() {
    super();
    this.init();
  }

  private init(): void {
    this.setupTabs();
  }

  private setupTabs(): void {
    this.selectElements('.js-simple-tab').forEach(tab => {
      const t = new Tab(tab);
    });
  }
}

export default TabControler;
